// extracted by mini-css-extract-plugin
module.exports = {"verticalText":"styles_verticalText__1Fg7n","horizontalBarsWrapper":"styles_horizontalBarsWrapper__36nvB","barName":"styles_barName__h2KNl","bar":"styles_bar__2-AgX"};